const PluginData = [
  {
    pluginId: 1,
    icon: '/media/plugins/jstree/profileQuestions.jpg',
    name: 'Category And Subcategory',
    type: 'Tool',
    description: 'Customize your categories and subcategories',
    status: 'Active',
    path: 'category_plugin',
  },
  {
    pluginId: 2,
    icon: '/media/plugins/jstree/rewards.jpg',
    name: 'Rewards',
    type: 'Software',
    description: 'Give free Offers to users after complete some tasks in the site',
    status: 'Active',
    path: 'reward_plugin',
  },
  {
    pluginId: 3,
    icon: '/media/plugins/jstree/credits.jpg',
    name: 'Site pricing',
    type: 'Software',
    description: 'Update the credits and premium pricing details',
    status: 'Active',
    path: 'site_pricing_plugin',
  },
  {
    pluginId: 4,
    icon: '/media/plugins/jstree/settings.jpg',
    name: 'General Settings',
    type: 'Software',
    description: 'Software general settings',
    status: 'Active',
    path: 'general_plugin',
  },

  {
    pluginId: 6,
    icon: '/media/plugins/jstree/terms.jpg',
    name: 'Legal information',
    type: 'Pages',
    description: 'Edit your site terms of use, privacy policy and cookies',
    status: 'Active',
    path: 'legal_information_plugin',
  },

  {
    pluginId: 8,
    icon: '/media/plugins/jstree/phonepe.png',
    name: 'Phone Pay',
    type: 'Payment',
    description: 'Edit Phone Pay Gateways',
    status: 'Active',
    path: 'phone_pay_payment_plugin',
  },
  {
    pluginId: 9,
    icon: '/media/plugins/jstree/razorpay.png',
    name: 'Razor Pay',
    type: 'Payment',
    description: 'Edit Razor Pay Gateways',
    status: 'Active',
    path: 'razor_pay_payment_plugin',
  },
  {
    pluginId: 10,
    icon: '/media/plugins/jstree/cashfree.png',
    name: 'Cash Free',
    type: 'Payment',
    description: 'Edit Cash Free',
    status: 'Active',
    path: 'cash_free_payment_plugin',
  },
  {
    pluginId: 11,
    icon: '/media/plugins/jstree/folder.webp',
    name: 'Folder Structure',
    type: 'Software',
    description: 'Edit Folder Size in Folder Structure',
    status: 'Active',
    path: 'folder_structure_plugin',
  },
  {
    pluginId: 12,
    icon: '/media/plugins/jstree/smtp.png',
    name: 'SMTP config',
    type: 'Tools',
    description: 'you can change dynamically configuration of smtp ',
    status: 'Active',
    path: 'smtp_plugin',
  },
  {
    pluginId: 13,
    icon: '/media/plugins/jstree/ads.jpg',
    name: 'Ads config',
    type: 'Tools',
    description: 'you can change dynamically configuration of ads',
    status: 'Active',
    path: 'ads_plugin',
  },
  {
    pluginId: 14,
    icon: '/media/plugins/jstree/ads-planner.webp',
    name: 'Ads Planner',
    type: 'Tools',
    description: 'you can change dynamically configuration of Ads Planner',
    status: 'Active',
    path: 'ads_plan_plugin',
  },
  {
    pluginId: 15,
    icon: '/media/plugins/jstree/notification.png',
    name: 'Notification',
    type: 'Tools',
    description: 'Customize your Notifications',
    status: 'Active',
    path: 'notification_plugin',
  },
  {
    pluginId: 16,
    icon: '/media/plugins/jstree/banner.png',
    name: 'Banner',
    type: 'Tools',
    description: 'Customize your Banner',
    status: 'Active',
    path: 'banner_plugin',
  },
  {
    pluginId: 17,
    icon: '/media/plugins/jstree/banner.png',
    name: 'Store Setting Banner',
    type: 'Tools',
    description: 'Customize your Setting Banner',
    status: 'Active',
    path: 'store_setting_banner_plugin',
  },
  {
    pluginId: 18,
    icon: '/media/plugins/jstree/banner.png',
    name: 'User Setting Banner',
    type: 'Tools',
    description: 'Customize your Setting Banner',
    status: 'Active',
    path: 'user_setting_banner_plugin',
  },
  {
    pluginId: 19,
    icon: '/media/plugins/jstree/faqs.png',
    name: 'User Faqs',
    type: 'Tools',
    description: 'Customize your User Faqs',
    status: 'Active',
    path: 'user_faqs_plugin',
  },
  {
    pluginId: 20,
    icon: '/media/plugins/jstree/faqs.png',
    name: 'Store Faqs',
    type: 'Tools',
    description: 'Customize your Store Faqs',
    status: 'Active',
    path: 'store_faqs_plugin',
  },
  {
    pluginId: 21,
    icon: '/media/plugins/jstree/wasabi.jpg',
    name: 'Storage And Backup Setting',
    type: 'Tools',
    description: 'Customize your Storage And Backup Setting',
    status: 'Active',
    path: 'wasabi_faqs_plugin',
  },
]

export default PluginData
